import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { SelectOptions } from '@/components/ui/SelectOptions';
import { useGetWorkstations } from '@/hooks/useGetWorkstations';
import { FormItemWrapper } from '@/components/Settings/DataExtraction/styles';

const { useWatch } = Form;

export function WorkstationFormItem(): JSX.Element {
	const organization_id = useWatch('organization_id');
	const company_id = useWatch('company_id');
	const sector_id = useWatch('sector_id');
	const line_id = useWatch('line_id');

	const { isLoading: isLoadingWorkstations, data: workstations = [] } = useGetWorkstations({
		organization_id,
		company_id,
		sector_id,
		line_id
	});

	const isDisabled = !organization_id || !company_id || !sector_id || !line_id;
	const isLoading = !!organization_id && !!company_id && !!line_id && !!sector_id && isLoadingWorkstations;

	return (
		<FormItemWrapper name="workstation_id" label={I18n.get('Workstation')} labelCol={{ span: 24 }}>
			<SelectOptions
				allowClear
				loading={isLoading}
				disabled={isDisabled}
				options={workstations}
				placeholder={I18n.get('Workstation')}
			/>
		</FormItemWrapper>
	);
}
